import PropTypes from 'prop-types';

export default PropTypes.shape({
  taxYear: PropTypes.string,
  period: PropTypes.string,
  filingTypeId: PropTypes.string,
  businessEntityId: PropTypes.string,
  jurisdictionId: PropTypes.string,
});
